// src/App.js
import React from "react";
import VideoPlayer from "./components/VideoPlayer";

function App() {
  return (
    <div className="bg-white">
      <VideoPlayer />
    </div>
  );
}

export default App;
